class UserCardListController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
  }

  getModifiedCards(cardModified) {
    let modified = this._findCardModified(cardModified, this.employees);
    let event = this.EventEmitter(modified);
    this.onModify(event);
  }

  daysIsFocused($event) {
    let event = this.EventEmitter($event);
    this.cardDaysFocused(event);
  }

  _findCardModified(cardModified, employeeAray) {
    let modified = [];
    employeeAray.forEach((employee) => {
      employee.cards.forEach((card) => {
        if (card.state !== 'modified') return;
        modified.push(card);
      });
    });
    return modified;
  }
}

export default UserCardListController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardList.controller.js